module.exports = __webpack_public_path__ + "img/p8_03.d83e83c8.jpg";